<template>
    <v-dialog v-model="dialog" max-width="500px" persistent>
        <v-card class="pa-3">
            <v-card-title>
                <h2 class="title">Set Newsletter Clicks</h2>
            </v-card-title>

            <div v-if="loading" class="my-3 px-6">
                <v-progress-linear
                        :indeterminate="loading"
                        :class="{ 'no-opacity': !loading }"
                        style="height: 2px;"
                ></v-progress-linear>
            </div>
            <template v-else>
                <v-card-text class="mt-5">
                    <div>
                        <div class="px-2">
                            <v-autocomplete
                                :items="newsletters"
                                label="Newsletter"
                                item-text="name"
                                item-value="id"
                                class="mb-3"
                                v-model="preparedData.newsletter_id"
                                :error-messages="errors($v.preparedData.newsletter_id) || server_errors.newsletter_id"
                                placeholder="Please Select"
                                @focus="resetServerValidation"
                            ></v-autocomplete>
                            <v-autocomplete
                                :items="organizations"
                                label="Advertiser"
                                item-text="name"
                                item-value="id"
                                class="mb-3"
                                v-model="preparedData.organization_id"
                                placeholder="Please Select"
                                :error-messages="errors($v.preparedData.organization_id) || server_errors.organization_id"
                                @focus="resetServerValidation"
                            ></v-autocomplete>
                            <v-text-field
                                v-model="preparedData.link"
                                label="Link"
                                placeholder="Please Enter"
                                class="mb-4"
                                hint="Link needs to be in https://www.website.com format"
                                persistent-hint
                                :error-messages="errors($v.preparedData.link) || server_errors.link"
                                @focus="resetServerValidation"
                            ></v-text-field>
                            <v-autocomplete
                                :items="clickTypes"
                                label="Link Type"
                                item-text="name"
                                item-value="id"
                                class="mb-3"
                                v-model="preparedData.newsletter_click_type_id"
                                placeholder="Please Select"
                                :error-messages="errors($v.preparedData.newsletter_click_type_id) || server_errors.newsletter_click_type_id"
                                @focus="resetServerValidation"
                            ></v-autocomplete>
                            <v-text-field
                                v-model="preparedData.clicks"
                                label="Clicks"
                                placeholder="Please Enter"
                                :error-messages="errors($v.preparedData.clicks) || server_errors.clicks"
                                @focus="resetServerValidation"
                            ></v-text-field>
                            <!-- <template v-if="loadingNewslettersOrganizations">
                                <v-skeleton-loader
                                    type="paragraph"
                                    class="mx-auto mb-4"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    type="paragraph"
                                    class="mx-auto"
                                ></v-skeleton-loader>
                            </template>
                            <template v-if="!loadingNewslettersOrganizations && printAds !== null">

                                <v-file-input
                                    id="image"
                                    accept="image/png, image/jpeg, image/jpg, image/gif"
                                    ref="file" 
                                    name="image"
                                    show-size 
                                    label="Photo"
                                    placeholder="Please Select"
                                    v-model="preparedData.image"
                                    :error-messages="imageSizeErrors"
                                    @change="handleFileUploads"
                                ></v-file-input>
                            </template> -->
                        </div>
                        <v-alert class="pa-2 mt-6" :value="$v.$error" outlined color="error" icon="mdi-alert" transition="scale-transition">
                            <span class="caption">Please fill out form correctly</span>
                        </v-alert>
                        <v-alert class="pa-2 mt-3" :value="!serverValidation" outlined color="error" icon="mdi-alert"
                                 transition="scale-transition">
                            <span class="caption">{{ serverValidationMessage }}</span>
                        </v-alert>
                    </div>
                </v-card-text>

                <v-card-actions class="px-6">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeModal">Cancel</v-btn>
                    <v-btn
                        color="primary"
                        :disabled="loadingSave"
                        :loading="loadingSave"
                        @click="SetNewsletterClicks"
                    >Save
                    </v-btn>
                </v-card-actions>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
    import ApiService from "@/common/api.service"
    import { validationMixin } from "vuelidate"
    import { required, helpers, url, decimal } from "vuelidate/lib/validators"
    import { valMessages, getValMessage } from "@/common/error-messages"

    let validations = {
        preparedData: {
            newsletter_id: { required },
            organization_id: { required },
            link: { url },
            newsletter_click_type_id: { required },
            clicks: { required, decimal, notNegative: v => !helpers.req(v) || v >= 0 }
        }
    }

    export default {
        name: 'SetNewsletterClicks',
        mixins: [validationMixin],
        validations,
        data: () => ({
            no_data: [null, "", undefined, "null"],
            item: null,
            preparedData: {},
            newsletters: [],
            organizations: [],
            clickTypes: [],
            loading: false,
            loadingSave: false,
            loadingNewslettersList: false,
            loadingNewslettersOrganizations: false,
            loadingClickTypes: false,
            dialog: false,
            file: null,
            selectedFileHeight: null,
            selectedFileWidth: null,
            serverValidation: true,
            serverValidationMessage: "Oops something went wrong...",
            server_errors: {}
        }),
        mounted() {
            this.$root.$on('SetNewsletterClicks', this.openModal)
        },
        beforeDestroy() {
            this.$root.$off('SetNewsletterClicks', this.openModal)
        },
        methods: {
            getNewslettersList() {
                this.loadingNewslettersList = true;
                return new Promise((resolve, reject) => {
                    ApiService.get("/admin/newsletters/list")
                        .then(response => {
                            let data = response.data;
                            this.newsletters = data.newsletters
                            resolve(data);
                        })
                        .catch(({response}) => {
                            this.loadingNewslettersList = false;
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            reject();
                        });
                });
            },
            getNewslettersOrganizations () {
                this.loadingNewslettersOrganizations = true;
                return new Promise((resolve, reject) => {
                    ApiService.get("/admin/newsletters/organizations")
                    .then(response => {
                        let data = response.data;
                        this.organizations = data.organizations
                        this.loadingNewslettersOrganizations = false
                        resolve(data);
                    })
                    .catch(({ response }) => {
                        this.loadingNewslettersOrganizations = false
                        this.serverValidation = false;
                        if (response.data.error) {
                            this.serverValidationMessage = this.titleCase(
                                response.data.error
                            );
                        }
                        reject();
                    });
                });
            },
            getClickTypes () {
                this.loadingClickTypes = true;
                return new Promise((resolve, reject) => {
                    ApiService.get("/admin/newsletters/click_types")
                    .then(response => {
                        let data = response.data;
                        this.clickTypes = data.newsletter_clicks
                        this.loadingClickTypes = false
                        resolve(data);
                    })
                    .catch(({ response }) => {
                        this.loadingClickTypes = false
                        this.serverValidation = false;
                        if (response.data.error) {
                            this.serverValidationMessage = this.titleCase(
                                response.data.error
                            );
                        }
                        reject();
                    });
                });
            },
            openModal() {
                this.resetServerValidation()
                this.preparedData = {}
                this.$v.$reset()
                this.loading = true
                this.dialog = true
                this.loadingSave = false
                Promise.all([this.getNewslettersList(), this.getNewslettersOrganizations(), this.getClickTypes()])
                    .then(values => {
                        this.loading = false
                    })
                    .catch(error => {
                        this.resetServerValidation();
                        this.loading = false
                    });
            },
            SetNewsletterClicks() {
                this.resetServerValidation()
                this.$v.preparedData.$touch();
                if (!this.$v.preparedData.$invalid) {
                    this.loadingSave = true

                    const body = _.cloneDeep(this.preparedData)

                    ApiService.put('/admin/newsletter/clicks', body)
                        .then(response => {
                            this.$root.$emit("notification", {
                                status: "success",
                                text: 'Clicks have been successfully setted.'
                            });
                            this.loadingSave = false
                            this.$emit('done')
                            this.closeModal()
                        })
                        .catch(({response}) => {
                            this.loadingSave = false;
                            this.serverValidation = false;
                            if (response.data.error) {
                                this.serverValidationMessage = this.titleCase(
                                    response.data.error
                                );
                            }
                            if (response.data.message) {
                                this.serverValidationMessage = response.data.message;
                            }
                            if (response.data.errors) {
                                this.server_errors = response.data.errors;
                            }
                        });
                }
            },
            closeModal() {
                this.dialog = false
            },
            titleCase(str) {
                return _.startCase(str.replace(/_/g, " "));
            },
            handleFileUploads(event) {
                if(event) {
                    let image = event;
    
                    let imageFile = new Image()
    
                    let reader = new FileReader();
                    reader.readAsDataURL(image);
                    reader.onload = e => {
                        this.file = e.target.result
                        imageFile.src = e.target.result
                    }
    
                    imageFile.onload = function () {
                        this.selectedFileHeight = this.height;
                        this.selectedFileWidth = this.width;
                    };
                } else {
                    this.file = null,
                    this.selectedFileHeight = null,
                    this.selectedFileWidth = null,
                    delete this.preparedData.image
                }
            },
            resetServerValidation() {
                this.serverValidation = true;
                this.serverValidationMessage = "Oops something went wrong...";
                this.server_errors = {};
            },
            errors: getValMessage(valMessages)(validations)
        },
        computed: {
            imageSizeErrors: function () {
                if (this.preparedData.banner_type_id && this.file && this.selectedFileHeight && this.selectedFileWidth) {
                    let bannerType = this.bannerTypes.find(i => i.id === this.preparedData.banner_type_id)
                    if (this.selectedFileHeight !== bannerType.height || this.selectedFileWidth !== bannerType.width) {
                        return [`Image dimensions need to be ${bannerType.height}x${bannerType.width} (WxH)`]
                    } else {
                        return []
                    }
                }
            }
        },
        watch: {
            'preparedData.print_add_id': function(val) {
                if(!this.no_data.includes(val)) {
                    this.file = null
                    this.selectedFileHeight = null
                    this.selectedFileWidth = null
                    delete this.preparedData.image
                }
            }
        }
    }
</script>
